<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :seo-data="data ? data.latest_seo : null"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <translator
            v-if="baseDocument"
            :base-document="baseDocument"
            :document-type="documentType"
            :language="form.language"
        ></translator>

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <input-text
            label="* Name"
            name="name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength=200
        />

        <media-reference
            :language="form.language"
            v-model="form.logo"
            class="mt-3"
            label="Logo"
            name="logo_id"
            :media-types="['PaymentLogo']"
        />
        <input-checkbox
            name="is_crypto"
            label="Is this a crypto-currency?"
            class="mt-3"
            v-model="form.is_crypto"
            :error="errors.is_crypto ? errors.is_crypto[0] : null"
        />
        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";

export default {
    name: "PaymentMethodForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                name: this.getFormData("name"),
                logo_id: this.getFormData("logo_id"),
                logo: this.getFormData("logo"),
                is_crypto: this.getFormData("is_crypto"),
            },
        };
    },
    watch: {
        "form.logo": function(newValue){
            if(newValue) {
                this.form.logo_id = newValue.id
            }
        },
    }
};
</script>
